import React, { useEffect, useState } from 'react';
import { Button, Modal, } from 'react-bootstrap';

import { useAuth } from '../../../Auth';
import { useAxios } from '../../../AxiosHandler';
import { useTranslate } from 'react-polyglot';
import { toast } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';
import './InvoiceSender.scss';

function InvoiceSender(props) {
    const auth = useAuth();
    const t = useTranslate();
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;

    

    const notifySuccess = (text) => toast(text, {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        className: "success-toast"
    });

    const notifyWarning = (text) => toast(text, {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        className: "warning-toast"
    });

/*     const [showModal, setShowModal] = useState(false);
    const [updateTable, setUpdateTable] = useState(0);

    const [responseData, setResponseData] =useState<Array<Object>>([]);
    const [errorData, setErrorData] =useState<Array<Object>>([]);
    const [msgOkStatus, setMsgOkStatus] = useState("");

    const [status, setStatus] = useState("");
    const [message, setMessge] = useState(""); */

    /* const handleSendInvoice = () => {
        axios.post('/api/bookings/updatestatus/invoicemany/', {
            invoicedBookings: props.invoicedBookings,
        }
        ,{
            headers: {'x-access-token': auth.user["token"]}
        })
        .then(function (response) {
            notifySuccess(t("smssender.toast.sent"));
            props.onBilling();
        });
    }; */

    const [forceUpdate, setForceUpdate] = useState(0);

    const [checkedBookingIds, setCheckedBookingIds] = useState<Array<any>>([]);
    const [allBookings, setAllBookings] = useState<Array<any>>([]);


    function fetchBookings(){
        axios.all([
            axios.single({
                method: "get",
                url: "/api/bookings",
                responseType: "json",
                headers: { 'x-access-token': auth.user["token"] }
            }),
        ])
            .then(axios.spread((...res) => {
                setAllBookings(res[0].data);
                setCheckedBookingIds(props.invoicedBookings.map(booking => booking._id));
            }))
            .catch(err => console.log(err));
    }

    function generateInvoices(){
        let invoices = props.invoicedBookings.filter(booking => booking.invoices.length < 1).map(invoice => invoice._id);
        
        axios.post(
            "/api/invoicing/generateMultipleInvoices/", 
            {
                invoices: invoices
            }, {
                headers: { 'x-access-token': auth.user["token"] }
            }
        ).then(res => {
            if (props.onSend != undefined) props.onSend(res.data);
            notifySuccess(t("invoicesender.generate_success_toast"));
            setForceUpdate(forceUpdate + 1);
        }); 
    }

    function approveInvoices() {
        let invoices = props.invoicedBookings.filter(booking => booking.invoices.length >= 1 && booking.status != "invoiced").map(invoice => invoice._id);

        axios.post(
            "/api/invoicing/sendInvoices/", 
            {
                invoices: invoices
            }, {
                headers: { 'x-access-token': auth.user["token"] }
            }
        ).then(res => {
            if (props.onSend != undefined) props.onSend(res.data);
            notifySuccess(t("invoicesender.send_success_toast"));
        }); 
    }

    const handleOnCancel = () =>{
        if(props.onCancel != undefined) {
            props.onCancel();
        }
    }

    const handleOnHide = () =>{
        if(props.onHide != undefined) {
            props.onCancel();
        }
    }

/*     function getText() {
        let checkedBookingsIds = props.invoicedBookings.map(booking => booking._id);
        let checkedBookingObjects = allBookings.filter(booking => checkedBookingsIds.includes(booking["_id"]));

        checkedBookingObjects.map((booking, key) => {
            return <p key={key}>{booking["bookingnumber"]} - {booking["status"] == "invoiced" ? <span>{t("invoicesender.invoice_sent")}</span> : booking["invoices"] != undefined && booking["invoices"].length > 0 ? <span>{t("invoicesender.is_generated")}</span> : <span>{t("invoicesender.not_generated")}</span>} </p>
        })
        
    } */
    function createDownloadFiles(file, fileName, fileType){
        const blob = new Blob( [file], { type: 'text/plain' } );
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        // the filename you want
        a.download = fileName + "." + fileType;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
    }

    function handleDownloadInvoice(event) {
        let currentBookingObject = allBookings.find(i => i._id == event.target.id);
        let lastinvoice = "";
        if(currentBookingObject.invoices[currentBookingObject.invoices.length - 1] != undefined) {
            lastinvoice = currentBookingObject.invoices[currentBookingObject.invoices.length - 1].orderFileId;
            axios.post(
                "/api/invoicing/downloadOrderFile/",
                {
                    bookingId: event.target.id,
                    orderFileId: lastinvoice 
                }, {
                    headers: { 'x-access-token': auth.user["token"] }
                }
            ).then(res => {
                createDownloadFiles(res.data.file, res.data.filename, res.data.filetype);
            });

            axios.post(
                "/api/invoicing/downloadCustomerFile/",
                {
                    bookingId: event.target.id,
                    orderFileId: lastinvoice 
                }, {
                    headers: { 'x-access-token': auth.user["token"] }
                }
            ).then(res => {
                createDownloadFiles(res.data.file, res.data.filename, res.data.filetype);
            });
        } else {
            notifyWarning(t("invoicesender.invoice_not_generated_toast"))
        }
    }

    useEffect(() => {
        fetchBookings();
    }, [props.invoicedBookings, forceUpdate]);

    return (
        <Modal show={props.show} onHide={handleOnHide}>
            <Modal.Header closeButton>
                <Modal.Title>
                    {t("invoicesender.title_new")}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>{t("invoicesender.download_info")}</p>
                <hr />
                {allBookings.filter(booking => checkedBookingIds.includes(booking._id as String)).map((booking, key) => 
                    booking.customerId != undefined ?
                    <p key={key} className="invoice_line invoice_line_hover" id={booking._id} onClick={event => handleDownloadInvoice(event)}>{booking.bookingnumber} - {booking.status == "invoiced" ? t("invoicesender.invoice_sent") : booking.invoices != undefined && booking.invoices.length > 0 ? t("invoicesender.is_generated") : t("invoicesender.not_generated") } </p>
                    : <p key={key} className="invoice_line missing_customer_line" id={booking._id}>{booking.bookingnumber} - {t("invoicesender.missing_customer")}</p>
                )}
            
            {/* {props.invoicedBookings.map(booking =>
                props.allBookings.map(item =>
                    booking.id == item.id ? 
                    <p>{item.bookingnumber}</p>
                    : null)
                    // item._id == i._id ? <p> send invoices to {item._id}</p> : ""
                )
            } */}
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={handleOnCancel}>
                    {t("invoicesender.cancel")}
                </Button>
                <Button onClick={generateInvoices}>
                    {t("invoicesender.generate")}
                </Button>
                <Button onClick={approveInvoices}>
                    {t("invoicesender.send")}
                </Button>
            </Modal.Footer>
    </Modal>
    );
}

export default InvoiceSender;